import { Button, Divider } from "@mui/material";
import {useGetTransactionSummaryQuery} from '../../../../../services/PaymentToolApi';
import { useLocation, useHistory } from "react-router-dom";
import MoneyFormatter from "../../../../../components/moneyFormatter";
import {useEffect} from "react";
import TransactionSummary from "../components/transactionSummary";

const PaymentsByYearHeader = ({selectedYear, setSelectedYear, years}) => {

  const TableHeaderInfo = {
    padding: '1em',
    margin: '0 0 1px 0',
    borderRadius: '1em 1em 0 0',
    backgroundColor: 'white',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  }

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const history = useHistory();
  useEffect(() => {
    searchParams.set("year", selectedYear); //A: this is the index of the tab in the admin tools
    history.push(`/dashboard/admintools?${searchParams.toString()}`);
  }, [history]);
  return (
    <div style={TableHeaderInfo} >

      <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0' }} >
        <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Displayed Year:</p>
        <p style={{ whiteSpace: 'nowrap' }} > {selectedYear}</p>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }} >

        <TransactionSummary selectedYear={selectedYear}/>

      </div>


    </div>
  );
}

export default PaymentsByYearHeader;